import MD5 from 'crypto-js/md5'
import HmacSHA256 from 'crypto-js/hmac-sha256'
import Utf8 from 'crypto-js/enc-utf8'
import Base64 from 'crypto-js/enc-base64'
import store from '@/store'
import { authCookie } from '@/utils/auth'

const signRequest = (config) => {
  var bodyMd5 = ''
  if (config.data !== undefined) {
    var jsonBody = (typeof config.data !== 'string' ? JSON.stringify(config.data) : config.data)
    bodyMd5 = MD5(jsonBody).toString(Base64)
  } else {
    config.data = ''
  }

  config.headers['X-Timestamp'] = config.headers['X-Timestamp'] || getTimestamp()

  var urlObj = document.createElement('a')
  urlObj.href = config.url
  var path = (urlObj.pathname.indexOf('/') === 0) ? urlObj.pathname : '/' + urlObj.pathname

  config.method = config.method.toUpperCase().trim()

  var stringToSign = '' +
    config.method + '\n' +
    bodyMd5 + '\n' +
    (config.headers['Content-Type'] || '') + '\n' +
    'x-timestamp:' + config.headers['X-Timestamp'] + '\n' +
    path

  let session = JSON.parse(decodeURIComponent(authCookie()))
  let signature = HmacSHA256(Utf8.parse(stringToSign), Base64.parse(session.sessionSecret)).toString(Base64)
  config.headers.Authorization = instanceAuthorization(session.sessionId, signature)
}

const signRequesWebApi = (config) => {
  config.headers.Authorization = decodeURIComponent(authCookie())
}

const addTimestampHeader = (config) => {
  config.headers['X-Timestamp'] = config.headers['X-Timestamp'] || getTimestamp()
  return config
}

const applicationAuthorization = (applicationKey) => {
  return `application ${applicationKey}`
}

const tokenAuthorization = (authorizationToken) => {
  return `user ${authorizationToken}`
}

const instanceAuthorization = (sessionId, signature) => {
  return `instance ${sessionId}:${signature}`
}

const getTimestamp = () => {
  let diff = window.serverTimestampDiff || 0
  let dateWithDiff = new Date(new Date().getTime() + diff)
  return dateWithDiff.toISOString()
}

const acceptLanguageHeader = (config) => {
  try {
    config.headers['Accept-Language'] = store.getters['user/locale']
  } catch (ex) {

  }
}

export {
  signRequest,
  signRequesWebApi,
  addTimestampHeader,
  applicationAuthorization,
  tokenAuthorization,
  instanceAuthorization,
  getTimestamp,
  acceptLanguageHeader
}



// WEBPACK FOOTER //
// ./src/api/authorization.js